window.moveCarousel = function(direction) {
    const carousel = document.getElementById('custom-review-carousel');
    if (carousel) {
        const scrollAmount = carousel.offsetWidth;
        carousel.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
    }
};

(function() {
    const carouselContainer = document.getElementById('custom-review-carousel');
    let isPopulated = false;

    const scrapeKudosi = () => {
        if (isPopulated) return true;

        const widgetHost = document.querySelector('kudosi-review-widget, .alireviews-review-box');
        if (!widgetHost) return false;

        const root = widgetHost.shadowRoot || document;
        const items = root.querySelectorAll('.alr-wh-comp-review-item, [class*="review-item"]');
        
        if (items.length > 0) {
            const reviews = Array.from(items).map(item => {
                const contentEl = item.querySelector('.alr-wh-comp-text-content');
                let text = contentEl ? contentEl.innerText : "";
                text = text.replace(/See more/gi, '').replace(/Verified purchase/gi, '').trim();

                const authorEl = item.querySelector('.alr-wh-comp-author-name, [class*="author"]');
                let author = authorEl ? authorEl.innerText.replace(/Verified purchase/gi, '').trim() : "Verified Buyer";

                const ratingEl = item.querySelector('[data-score], [aria-label*="star"]');
                let rating = 5;
                if (ratingEl) {
                    const score = ratingEl.getAttribute('data-score') || ratingEl.getAttribute('aria-label');
                    rating = parseInt(score) || 5;
                }
                return { text, author, rating };
            }).filter(r => r.text.length > 5);

            if (reviews.length > 0) {
                carouselContainer.innerHTML = reviews.map(rev => `
                    <div style="
                        scroll-snap-align: start; 
                        min-width: 100%; 
                        max-width: 100%;
                        flex: 0 0 100%;
                        background: #000; 
                        color: #fff; 
                        padding: 10px 70px; 
                        border: none; 
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        text-align: center;
                        white-space: normal;
                        word-wrap: break-word;
                        box-sizing: border-box;
                    ">
                        <div style="color: #ffb800; margin-bottom: 10px; font-size: 18px;">
                            ${'★'.repeat(rev.rating)}
                        </div>

                        <p style="
                            font-size: 16px; 
                            line-height: 1.5; 
                            margin: 0 auto 10px auto; 
                            color: #fff;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            min-height: 3em; /* Consistent height for 1 or 2 lines */
                            max-width: 100%;
                        ">
                            "${rev.text}"
                        </p>

                        <p style="font-size: 13px; font-weight: bold; color: #aaa; text-transform: uppercase; margin: 0;">
                            — ${rev.author}
                        </p>
                    </div>
                `).join('');
                
                isPopulated = true;
                return true; 
            }
        }
        return false;
    };

    const checker = setInterval(() => {
        if (scrapeKudosi()) clearInterval(checker);
    }, 2000);

    setTimeout(() => clearInterval(checker), 20000);
})();
